import React, { Component } from 'react'
import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import { Row, Col } from 'react-flexbox-grid'
import Menu from 'react-burger-menu/lib/menus/slide'
import config from 'config'
import {
  // DonateModal,
  AppDisclaimer,
  AppFooter,
  Link,
  IyvBanner
} from '../../components'
import Styles from './App.css'
import imageSocialShare from '../../../static/images/iyv-social-share.jpg'

@asyncConnect([{
  promise: ({store: {dispatch, getState}}) => {
    return Promise.resolve()
  }
}])
@CSSModules(Styles, {allowMultiple:true})
export default class App extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
      debug: props.location.query.debug,
    }
  }

  clickMenu = () =>{
    this.setState({menuOpen: !this.state.menuOpen})
  }

  renderDebug = () => {
    // console.log('this.state:',this.state.debug )
    if( !this.state.debug ){ return null }
    return (
      <div styleName='debug-device'>
        <div styleName='visible-xs'> XS - mobile </div>
        <div styleName='visible-sm'> SM - tablet </div>
        <div styleName='visible-md'> MD - desktop </div>
        <div styleName='visible-lg'> LG - large desktop </div>
      </div>
    )
  }

  render() {
    const styles = {
      bmBurgerButton: {
        position: 'relative',
        // width: '1.25rem',
        // height: '1.1rem',
        float: 'right',
        cursor: 'pointer'
      },
      bmBurgerBars: {
        background: '#333',
        cursor: 'pointer'
      },
      bmIcon: {
        whiteSpace: 'nowrap',
        fontSize: '1.5em',
        fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      bmMenuWrap: {
        top: 0,
        zIndex: 10001,
        width: '80%',
        maxWidth: '80%'
      },
      bmCrossButton: {
        height: '1.6rem',
        width: '1.6rem',
        cursor: 'pointer'
      },
      bmCross: {
        background: '#333',
        cursor: 'pointer'
      },
      bmMenu: {
        background: 'white',
        padding: '0 2.5rem 0 0',
        fontSize: '1.15rem',
        top: 0,
        borderLeft: '1px solid #A3A3A3'
      },
      bmMorphShape: {
        fill: 'white'
      },
      bmItemList: {
        color: '#333',
        padding: '0 1rem 1rem 1rem',
        boxSizing: 'border-box'
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.76)',
        top: 0,
        left: 0,
        zIndex: 10000,
      }
    }

    config.app.head.meta = config.app.head.meta.map(( meta ) =>{
      // since config.js doesnt have access to import, we will inject the image path here
      // after a replacement of the absolute url with
      if( meta.property === 'og:image' || meta.property === 'twitter:image'){
        meta.content = config.domain+imageSocialShare.replace(/.*dist/,'/dist')
      }
      return meta
    })

    const iyvLogo = require( '../../../static/images/iyv-logo-sm.png' )

    return (
      <div styleName='main'>
        <div id='anchor-top'/>
        <Helmet {...config.app.head}/>
        { /* <DonateModal /> */ }
        <div styleName='header-container-wrap'>
          <div styleName='header-container'>
            <div styleName='header-container-inner'>
              { this.renderDebug() }
              <div styleName='header-title'>
                <Link
                  to={config.routes.home}
                  title='Invest Your Values'
                >
                  <img
                    src={iyvLogo}
                    styleName='header-title-img'
                    alt='Invest Your Values'
                  />
                </Link>
              </div>
              <div styleName='hidden-xs donate-btn-wrap'>
                <Link
                  to={config.links.donate}
                  title='Donate to As You Sow'
                  headerdonatebutton
                >
                  Donate
                </Link>
              </div>
              <div styleName='menu-wrap'>
                <Menu
                  styles={styles}
                  isOpen={this.state.menuOpen}
                  burgerButtonClassName=''
                  customBurgerIcon={
                    (
                      <span>
                        <div style={{fontSize: '0.75em'}}>
                          Menu
                        </div>
                        <div>
                          &nbsp;&nbsp;<i className='fa fa-bars'/>
                        </div>
                      </span>
                    )
                  }
                  right
                >
                  <nav>
                    <Row>
                      <Col xs={12} md={4} styleName='menu-column'>
                        <div styleName='menu-link'>
                          <Link
                            to={config.routes.home}
                            title='Home'
                          >
                            Home
                          </Link>
                        </div>
                        <div styleName='menu-link' >
                          <Link
                            to={config.routes.issues}
                            title='The issues'
                          >
                            The issues
                          </Link>
                        </div>
                        <div>
                          <div styleName='menu-link-sublabel'>
                            Environment
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueFossilFuels}
                              title='The issues: Fossil fuels'
                            >
                              Fossil fuels
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueFossilFuelFinanceInsurance}
                              title='The issues: Fossil fuel finance & insurance'
                            >
                              Fossil fuel finance & insurance
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueDeforestation}
                              title='The issues: Deforestation'
                            >
                              Deforestation
                            </Link>
                          </div>
                          <div styleName='menu-link-sublabel'>
                            Social
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueGenderEquality}
                              title='The issues: Gender equality'
                            >
                              Gender equality
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueCivilianFirearms}
                              title='The issues: Civilian firearms'
                            >
                              Civilian firearms
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issuePrisonIndustrialComplex}
                              title='The issues: Prison industrial complex'
                            >
                              Prison industrial complex
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueArmsManufacturers}
                              title='The issues: Arms manufacturers'
                            >
                              Arms manufacturers
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.issueTobacco}
                              title='The issues: Tobacco'
                            >
                              Tobacco
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md={4} styleName='menu-column'>
                        <div styleName='menu-link'>
                          <Link
                            to={config.routes.solutions}
                            title='The solutions'
                          >
                            The solutions
                          </Link>
                        </div>
                        <div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.solutionOfferSustainability}
                              title='Offer sustainable investments'
                            >
                              Offer sustainable investments
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.solutionDefaultSustainability}
                              title='Make the default investment sustainable'
                            >
                              Make the default investment sustainable
                            </Link>
                          </div>
                        </div>
                        <div styleName='menu-link'>
                          <Link
                            to={config.routes.data}
                            title='The data'
                          >
                            The data
                          </Link>
                        </div>
                        <div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.plans}
                              title='The data: Retirement plans'
                            >
                              Retirement plans
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.targetDateFunds}
                              title='The data: Target date funds'
                            >
                              Target date funds
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.mutualFundsETFs}
                              title='The data: Mutual funds & ETFs'
                            >
                              Mutual funds & ETFs
                            </Link>
                          </div>
                          { /*
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.assetManagers}
                              title='The data: Asset managers'
                            >
                              Asset managers
                            </Link>
                          </div>
                          */ }
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.companies}
                              title='The data: Publicly-traded companies'
                            >
                              Publicly-traded companies
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.fossilFuelBondsIn401ks}
                              title='The data: Fossil fuel bonds in 401(k)s'
                            >
                              Fossil fuel bonds in 401(k)s
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.howitworks}
                              title='The data: Methodology'
                            >
                              Methodology
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md={4} styleName='menu-column'>
                        <div styleName='menu-link'>
                          <Link
                            to={config.routes.eduCenter}
                            title='Action center'
                          >
                            Action center
                          </Link>
                        </div>
                        <div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.eduCenterIndividual}
                              title='For employees'
                            >
                              For employees
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.eduCenterPlanAdmins}
                              title='For plan administrators'
                            >
                              For plan administrators
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.eduCenterFinRisks}
                              title='Financial risks of unsustainable investments'
                            >
                              Financial risks of unsustainable investments
                            </Link>
                          </div>
                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.fossilFuelBondRisks}
                              title='Financial risks of fossil fuel bonds'
                            >
                              Financial risks of fossil fuel bonds
                            </Link>
                          </div>

                          <div styleName='menu-link-alt'>
                            <Link
                              to={config.routes.faqs}
                              title='FAQs'
                            >
                              FAQs
                            </Link>
                          </div>
                        </div>
                        <div styleName='menu-link'>
                          <Link
                            to={config.routes.about}
                            title='About us'
                          >
                            About us
                          </Link>
                        </div>
                        <div styleName='menu-link-alt'>
                          <Link
                            to={config.links.contact}
                            title='Contact us'
                          >
                            Contact us
                          </Link>
                        </div>
                        <div styleName='menu-link-alt'>
                          <Link
                            to={config.routes.legal}
                            title='Legal disclaimer'
                          >
                            Legal disclaimer
                          </Link>
                        </div>
                        <div styleName='menu-link'>
                          <Link
                            to={config.links.signup}
                            title='Sign up for email updates'
                          >
                            Sign up for email updates
                          </Link>
                        </div>
                        <div>
                          <Link
                            to={config.links.donate}
                            title='Donate to As You Sow'
                            headerdonatebutton
                          >
                            Donate
                          </Link>
                        </div>
                        <br />
                      </Col>
                    </Row>
                  </nav>
                  <IyvBanner hideTagline hideLink />
                </Menu>
              </div>
            </div>
          </div>
        </div>
        <div styleName='content'>
          {this.props.children}
        </div>
        <AppFooter hideSiteMap/>
        <AppDisclaimer />
      </div>
    )
  }
}

